module.exports = require('regenerate')(0x640).addRange(0x1E900, 0x1E94A).addRange(0x1E950, 0x1E959).addRange(0x1E95E, 0x1E95F);